import React, {useCallback, useRef} from "react";
import isEmpty from "is-empty";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Pagination, Thumbs} from "swiper/modules";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import {isDesktop} from "@/Helpers/Function";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import CatalogCard from "@/Components/Site/CatalogCard";
import Picture from "@/Components/Picture";
import "@/Scss/Site/Wedding/index.scss";

const Index = (props) => {
    const {brideProducts = [], groomProducts = []} = props;

    return <BaseLayout {...props}>
        <section className={`section section--wedding`}>
            <div className={`container`}>
                <div className={`wedding`}>
                    <div className={`wedding--mainImage`}>
                        <Picture
                            src={`/storage/img/wedding/mainImage.jpg`}
                            srcMobile={`/storage/img/wedding/mainImageMobile.jpg`}
                            alt={`Свадьба`}
                        />
                    </div>
                    <div className={`wedding--categories`}>
                        <Link href={`/catalog/kolca/obruchalnye`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/obruchalnye.jpg`} alt={`obruchalnye`} />
                            <p className={`wedding--categoriesText`}>Все обручальные кольца</p>
                        </Link>
                        <Link href={`/catalog/kolca/obruchalnye/klassika`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/klassika.jpg`} alt={`klassika`} />
                            <p className={`wedding--categoriesText`}>Классические</p>
                        </Link>
                        <Link href={`/catalog/kolca/obruchalnye/shajba`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/shajba.jpg`} alt={`shajba`} />
                            <p className={`wedding--categoriesText`}>Шайба</p>
                        </Link>
                        <Link href={`/catalog/kolca/obruchalnye/dvuhsplavnye`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/dvuhsplavnye.jpg`} alt={`dvuhsplavnye`} />
                            <p className={`wedding--categoriesText`}>Двухсплавные</p>
                        </Link>
                        <Link href={`/catalog/kolca/obruchalnye/dizajnerskie`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/dizajnerskie.jpg`} alt={`dizajnerskie`} />
                            <p className={`wedding--categoriesText`}>Дизайнерские</p>
                        </Link>
                        <Link href={`/catalog/kolca/venchalnye`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/venchalnye.jpg`} alt={`venchalnye`} />
                            <p className={`wedding--categoriesText`}>Венчальные</p>
                        </Link>
                        <Link href={`/catalog/kolca/obruchalnye/brilliant`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/brilliant.jpg`} alt={`brilliant`} />
                            <p className={`wedding--categoriesText`}>С бриллиантами</p>
                        </Link>
                        <Link href={`/catalog/kolca/obruchalnye/fianit`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/fianit.jpg`} alt={`fianit`} />
                            <p className={`wedding--categoriesText`}>С фианитами</p>
                        </Link>
                        <Link href={`/catalog/kolca/obruchalnye/platina`} className={`wedding--categoriesItem`}>
                            <Picture src={`/storage/img/wedding/categories/platina.jpg`} alt={`platina`} />
                            <p className={`wedding--categoriesText`}>Из платины</p>
                        </Link>
                    </div>
                    <div className={`wedding--ringsImage`}>
                        <Link href={`catalog/kolca/pomolvochnye`} className={``}>
                            <Picture src={`/storage/img/wedding/ringsImage_v1.jpg`} alt={`Помолвочные кольца`} />
                        </Link>
                    </div>
                    <div className={`wedding--brideAndGroomContainer`}>
                        <div className={`wedding--brideAndGroom`}>
                            <Link
                                href={`/catalog/dlya-zhenschin/dlya-svadby`}
                                className={`wedding--brideAndGroomImage`}
                            >
                                <Picture src={`/storage/img/wedding/bride_v1.jpg`} alt={`Для невесты`} />
                            </Link>
                            <Slider {...props} products={brideProducts} />
                        </div>
                        <div className={`wedding--brideAndGroom`}>
                            <Slider {...props} products={groomProducts} />
                            <Link href={`/catalog/dlya-muzhchin/dlya-svadby`} className={`wedding--brideAndGroomImage`}>
                                <Picture src={`/storage/img/wedding/groom_v1.jpg`} alt={`Для жениха`} />
                            </Link>
                        </div>
                    </div>
                    <div className={`wedding--buttons`}>
                        <Link href={`/catalog/dlya-svadby`} className={`button button--wedding`}>
                            Смотреть все украшения
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    </BaseLayout>
}

const Slider = (props) => {
    const {products = []} = props;

    if (isEmpty(products) || !isDesktop()) {
        return null;
    }

    const {registerView} = useViewItemBatcher();
    const swiperRef = useRef(null);
    const settings = {
        // autoplay: true,
        loop: true,
        spaceBetween: 10,
        slidesPerView: products.length <= 3 ? products.length : 3,
        // freeMode: true,
        pagination: {
            clickable: true,
            dynamicBullets: true,
        },
        // navigation: true,
        className: 'weddingSlider',
        modules: [Autoplay, Thumbs, Navigation, Pagination],
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: products.length <= 2 ? products.length : 2,
                pagination: {
                    clickable: true,
                    dynamicBullets: true,
                },
            },
            // when window width is >= 577px
            577: {
                slidesPerView: products.length <= 3 ? products.length : 3,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: products.length <= 3 ? products.length : 3,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: products.length <= 2 ? products.length : 2,
                pagination: false,
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: products.length <= 2 ? products.length : 2,
                pagination: false,
            },
            // when window width is >= 1366px
            1366: {
                slidesPerView: products.length <= 3 ? products.length : 3,
                pagination: false,
            },
        }
    };

    const elements = products.map((product, i) => {
        return <SwiperSlide key={product.id}>
            <CatalogCard
                el={product}
                {...props}
                index={i + 1}
                registerView={registerView}
            />
        </SwiperSlide>
    });

    const ArrowPrev = () => {
        let className = 'swiperNavigationContainer__arrow swiperNavigationContainer__arrow_left';

        const handlePrev = useCallback(() => {
            if (!swiperRef.current) return;
            swiperRef.current.swiper.slidePrev();
        }, []);

        return <div className={className} onClick={handlePrev}>
            <Svg id={`arrows-left`} className={`svg__swiperArrow`} />
        </div>
    }

    const ArrowNext = () => {
        let className = 'swiperNavigationContainer__arrow swiperNavigationContainer__arrow_right';

        const handleNext = useCallback(() => {
            if (!swiperRef.current) return;
            swiperRef.current.swiper.slideNext();
        }, []);

        return <div className={className} onClick={handleNext}>
            <Svg id={`arrows-right`} className={`svg__swiperArrow`} />
        </div>
    }

    return (
        <div className={`wedding--brideAndGroomSlider`}>
            <Swiper ref={swiperRef} {...settings}>
                {elements}
            </Swiper>
            <ArrowPrev />
            <ArrowNext />
        </div>
    );
}

export default Index;
